<template>
  <v-container fluid fill-height class="container-follow-up">
    <v-row no-gutters align-self="center" justify="center">
      <v-col>
        <v-row class="container-follow-up-title" no-gutters justify="center" align="center">
          <v-col cols="11" style="text-align: center" align-self="center">
            <v-col
              lg="10"
              sm="12"
              class="textarea-title"
              :style="
                $vuetify.breakpoint.width < 960
                  ? 'display: inline-block; padding: 0'
                  : 'display: inline-block; padding: 0'
              "
            >
              <v-tooltip
                v-if="currentClip"
                bottom
                nudge-top="10"
                :color="titleTooltip && currentClip['clipTitle'] ? '#131b1e' : 'transparent'"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="currentClip['clipTitle']"
                    ref="titleTxtF"
                    class="titleTxtF"
                    rows="1"
                    solo
                    no-resize
                    hide-details
                    background-color="transparent"
                    flat
                    dense
                    dark
                    :style="
                      $vuetify.breakpoint.width < 960
                        ? 'font-size: 20px !important; font-weight: 700'
                        : 'font-size: 35px !important; font-weight: 700'
                    "
                    @focus="titleTooltip = false"
                    @blur="saveClip()"
                    @keyup.enter="saveClip()"
                    :placeholder="
                      selectedMember
                        ? selectedMember.userDisplayName
                          ? selectedMember.userDisplayName + ' is requested to respond.'
                          : selectedMember.userFullName
                          ? selectedMember.userFullName + ' is requested to respond.'
                          : 'Untitled'
                        : 'Untitled'
                    "
                    :readonly="!isClipOrganizer"
                    v-on="on"
                  ></v-text-field>
                </template>
                <span v-if="titleTooltip && currentClip['clipTitle']">
                  {{ currentClip['clipTitle'] ? currentClip['clipTitle'] : 'Untitled' }}
                </span>
              </v-tooltip>
            </v-col>
          </v-col>
          <v-col cols="11" style="text-align: center" align-self="center">
            <v-col
              lg="10"
              sm="12"
              class="textarea-desc"
              :style="
                $vuetify.breakpoint.width < 960 ? 'display: inline-block; padding-top: 0' : 'display: inline-block'
              "
            >
              <v-textarea
                v-if="currentClip['clipNote'] || isClipOrganizer"
                v-model="currentClip['clipNote']"
                ref="noteTxtF"
                rows="2"
                solo
                no-resize
                hide-details
                background-color="transparent"
                flat
                dense
                dark
                :style="
                  $vuetify.breakpoint.width < 960
                    ? 'font-size: 12px !important; font-weight: 400'
                    : 'font-size: 13px !important; font-weight: 400'
                "
                @blur="saveClip()"
                @keyup.enter="saveClip()"
                :placeholder="isClipOrganizer ? 'Add additional note' : ''"
                :disabled="!isClipOrganizer"
              ></v-textarea>
            </v-col>
          </v-col>
          <v-col cols="11" style="text-align: center" align-self="center" class="pa-0">
            <v-col cols="12" style="text-align: center" align-self="center" class="pa-0">
              <v-row dense>
                <v-col cols="4" align-self="center" style="text-align: right">
                  <span
                    :style="
                      $vuetify.breakpoint.width < 960
                        ? 'color: #96a7af; font-size: 12px; font-weight: 400'
                        : 'color: #96a7af; font-size: 13px; font-weight: 400; padding-right: 15px'
                    "
                  >
                    Assigned To
                  </span>
                </v-col>
                <v-col cols="7" style="text-align: left">
                  <span class="white--text cent">
                    <v-menu offset-y transition="slide-y-transition" bottom dark>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="#161d21"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          :class="$vuetify.breakpoint.width < 960 ? 'pa-4' : 'pa-5'"
                          :style="$vuetify.breakpoint.width < 960 ? 'width: 150px' : 'min-width: 350px'"
                          :disabled="!isClipOrganizer"
                          :loading="isMemberLoading || isClipUpdateLoading"
                        >
                          <v-avatar
                            v-if="selectedMember"
                            :color="
                              !selectedMember.userPicture
                                ? selectedMember.userDisplayName || selectedMember.userFullName
                                : '' | iconBackground
                            "
                            class="logo mr-2"
                            round
                            :size="$vuetify.breakpoint.width < 960 ? '20' : '30'"
                            :style="selectedMember.userPicture == 'Anyone' ? 'border: solid 1px white' : ''"
                          >
                            <div
                              class="avatar-bg"
                              v-if="selectedMember.userPicture && selectedMember.userPicture !== 'Anyone'"
                            ></div>
                            <span class="white--text text-h7 cent" v-if="!selectedMember.userPicture">
                              {{ selectedMember.userDisplayName || selectedMember.userFullName | iconFilter }}
                            </span>
                            <span
                              v-else-if="selectedMember.userPicture == 'Anyone'"
                              class="material-icons-round mt-1"
                              style="color: white; font-size: 24px"
                              translate="no"
                            >
                              diversity_3
                            </span>
                            <v-img :src="selectedMember.userPicture" v-else />
                          </v-avatar>
                          <v-avatar
                            v-else
                            class="logo mr-2"
                            round
                            :size="$vuetify.breakpoint.width < 960 ? '20' : '30'"
                            style="border: solid 1px white"
                          >
                            <span
                              class="material-icons-round mt-1"
                              style="color: white; font-size: 24px"
                              translate="no"
                            >
                              diversity_3
                            </span>
                          </v-avatar>

                          <span
                            :style="
                              selectedMember
                                ? $vuetify.breakpoint.width < 960
                                  ? 'font-weight: 500; font-size: 13px; letter-spacing: 0px;'
                                  : 'font-weight: 500; font-size: 14px; letter-spacing: 0px;'
                                : $vuetify.breakpoint.width < 960
                                ? 'font-size: 13px; font-weight: 600'
                                : 'font-size: 14px; font-weight: 600'
                            "
                          >
                            {{
                              selectedMember ? selectedMember.userDisplayName || selectedMember.userFullName : 'Anyone'
                            }}
                          </span>
                          <span
                            v-if="isClipOrganizer && $vuetify.breakpoint.width > 960"
                            class="material-icons-round ml-1 mt-1"
                            :style="
                              $vuetify.breakpoint.width < 960
                                ? 'color: #ccc; font-size: 20px; cursor: pointer; position: absolute; right: 0'
                                : 'color: #ccc; font-size: 24px; cursor: pointer; position: absolute; right: 0'
                            "
                            translate="no"
                          >
                            expand_more
                          </span>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item v-for="(item, index) in memberList" :key="index" @click="selectMember(item)">
                          <v-avatar
                            :color="!item.userPicture ? item.userDisplayName || item.userFullName : '' | iconBackground"
                            class="logo mr-2"
                            round
                            :size="$vuetify.breakpoint.width < 960 ? '20' : '24'"
                            :style="item.userPicture == 'Anyone' ? 'border: solid 1px white' : ''"
                          >
                            <div class="avatar-bg" v-if="item.userPicture && item.userPicture !== 'Anyone'"></div>
                            <span class="white--text text-h7 cent" v-if="!item.userPicture">
                              {{ item.userDisplayName || item.userFullName | iconFilter }}
                            </span>
                            <span
                              v-else-if="item.userPicture == 'Anyone'"
                              class="material-icons-round"
                              style="color: white; font-size: 22px"
                              translate="no"
                            >
                              diversity_3
                            </span>
                            <v-img :src="item.userPicture" v-else />
                          </v-avatar>
                          <v-list-item-title style="font-size: 13px; letter-spacing: -0.3px !important">
                            {{ item.userDisplayName || item.userFullName }}
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </span>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" style="text-align: center" align-self="center" class="pa-0">
              <v-row class="mt-3" dense>
                <v-col cols="4" align-self="center" style="text-align: right">
                  <span
                    :style="
                      $vuetify.breakpoint.width < 960
                        ? 'color: #96a7af; font-size: 12px; font-weight: 400'
                        : 'color: #96a7af; font-size: 13px; font-weight: 400; padding-right: 15px'
                    "
                  >
                    Requested By
                  </span>
                </v-col>
                <v-col cols="7" style="text-align: left">
                  <div
                    :style="
                      $vuetify.breakpoint.width < 960
                        ? 'width: 150px; text-align: center'
                        : 'width: 350px; text-align: center'
                    "
                  >
                    <v-avatar
                      :color="
                        !currentClip.clipUploader.userPicture
                          ? currentClip.clipUploader.userDisplayName || currentClip.clipUploader.userFullName
                          : '' | iconBackground
                      "
                      class="logo mr-2"
                      round
                      :size="$vuetify.breakpoint.width < 960 ? '22' : '28'"
                    >
                      <div class="avatar-bg" v-if="currentClip.clipUploader.userPicture"></div>
                      <span class="white--text text-h7 cent" v-if="!currentClip.clipUploader.userPicture">
                        {{
                          currentClip.clipUploader.userDisplayName || currentClip.clipUploader.userFullName | iconFilter
                        }}
                      </span>
                      <v-img :src="currentClip.clipUploader.userPicture" v-else />
                    </v-avatar>
                    <span
                      :style="
                        $vuetify.breakpoint.width < 960
                          ? 'font-weight: 500; font-size: 13px; letter-spacing: 0px'
                          : 'font-weight: 500; font-size: 14px; letter-spacing: 0px'
                      "
                    >
                      {{ currentClip.clipUploader.userDisplayName || currentClip.clipUploader.userFullName }}
                    </span>
                  </div>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" style="text-align: center" align-self="center" class="pa-0">
              <v-row class="mt-3 mb-1" dense>
                <v-col cols="4" align-self="center" style="text-align: right">
                  <span
                    :style="
                      $vuetify.breakpoint.width < 960
                        ? 'color: #96a7af; font-size: 12px; font-weight: 400'
                        : 'color: #96a7af; font-size: 13px; font-weight: 400; padding-right: 15px'
                    "
                  >
                    Due Date
                  </span>
                </v-col>
                <v-col cols="7" style="text-align: left">
                  <v-btn
                    color="#161d21"
                    dark
                    :class="$vuetify.breakpoint.width < 960 ? 'pa-4' : 'pa-5'"
                    :style="$vuetify.breakpoint.width < 960 ? 'min-width: 150px' : 'min-width: 350px'"
                    :disabled="!isClipOrganizer"
                    @click="openDialog"
                    :loading="isMemberLoading || isClipUpdateLoading"
                  >
                    <span class="dialog-user-name ml-2">
                      {{ dueDate ? dueDate : isClipOrganizer ? 'Add due date' : '-' }}
                    </span>
                    <span
                      v-if="isClipOrganizer && $vuetify.breakpoint.width > 960"
                      class="material-icons-round ml-2"
                      :style="
                        $vuetify.breakpoint.width < 960
                          ? 'color: #ccc; font-size: 14px; cursor: pointer; font-weight: 400; position: absolute; right: 0'
                          : 'color: #ccc; font-size: 17px; cursor: pointer; font-weight: 400; position: absolute; right: 0'
                      "
                      translate="no"
                    >
                      edit_calendar
                    </span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <!-- <span class="white--text cent">{{ $t('notiRequestFollowUpTitle') }}</span> -->
          </v-col>
        </v-row>
        <!-- </v-card> -->
        <!-- <v-row
          class="mt-2"
          v-if="isShowRequestedBy || isShowClipTitle || isShowDueDate"
          justify="center"
          align="center"
          no-gutters
        >
          <v-card class="container-requested-by-info px-0 py-2 px-md-8 py-md-5" flat color="rgb(49, 67, 79)">
            <v-row v-if="isShowRequestedBy" no-gutters justify="center" align="center" style="min-height: 45px">
              <v-col class="container-requested-by-info-title pr-3" cols="3" align="right">
                {{ $t('requestedBy') }}
              </v-col>
              <v-col class="ontainer-requested-by-info-content ml-4 py-1">
                <v-row no-gutters align="center" justify="center">
                  <v-col cols="12">
                    <attendee
                      :mtOrganizerUid="currentMt.mtOrganizerUid"
                      :list="[currentClip.clipUploader]"
                      :isAdd="false"
                      size="30"
                      border="rgb(49, 67, 79)"
                      style="display: inline-block; margin-right: 20px"
                    ></attendee>
                    <span
                      v-if="currentClip.clipUploader"
                      class="white--text cent"
                      style="font-weight: 700; font-size: 12px; line-height: 20px"
                    >
                      {{ currentClip.clipUploader.userDisplayName || currentClip.clipUploader.userFullName }}
                    </span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row no-gutters justify="start" align="center" style="min-height: 45px">
              <v-col class="container-requested-by-info-title pr-3" cols="3" align="right">{{ $t('about') }}</v-col>
              <v-col class="container-requested-by-info-content ml-4 py-1">
                {{ isShowClipTitle ? currentClip.clipTitle : '-' }}
              </v-col>
            </v-row>
            <v-row no-gutters justify="start" align="center" style="min-height: 45px">
              <v-col class="container-requested-by-info-title pr-3" cols="3" align="right">{{ $t('dueDate') }}</v-col>
              <v-col class="container-requested-by-info-content ml-4 py-1">
                {{ isShowDueDate ? dueDate : '-' }}
              </v-col>
            </v-row>
          </v-card>
        </v-row> -->
        <v-row
          v-if="isMemberLoading || isClipUpdateLoading || isShowSelectRecordType"
          class="container-follow-up-title mt-2 mt-md-8"
          no-gutters
          justify="center"
          align="center"
        >
          <span v-if="isMemberLoading || isClipUpdateLoading" class="white--text cent mb-1">
            <v-skeleton-loader class="mx-auto mt-2" width="250" height="30" type="text" dark></v-skeleton-loader>
          </span>
          <span v-else class="white--text cent mb-3">
            {{ 'Are you ready to record?' }}
          </span>
        </v-row>
        <v-row
          v-if="isMemberLoading || isClipUpdateLoading || isShowSelectRecordType"
          class="mt-0 mt-md-3"
          no-gutters
          justify="center"
          align="center"
          style="width: 100%"
        >
          <span v-if="isMemberLoading || isClipUpdateLoading" class="white--text cent mb-1 container-skeleton-btns">
            <v-skeleton-loader
              class="mr-2 container-skeleton-btn"
              type="card"
              dark
              style="display: inline-block"
            ></v-skeleton-loader>
            <!-- <v-skeleton-loader
              class="mr-2 container-skeleton-btn"
              type="card"
              dark
              style="display: inline-block"
            ></v-skeleton-loader>
            <v-skeleton-loader
              class="mr-2 container-skeleton-btn"
              type="card"
              dark
              style="display: inline-block"
            ></v-skeleton-loader>
            <v-skeleton-loader
              class="mr-2 container-skeleton-btn"
              type="card"
              dark
              style="display: inline-block"
            ></v-skeleton-loader>
            <v-skeleton-loader
              class="container-skeleton-btn"
              type="card"
              dark
              style="display: inline-block"
            ></v-skeleton-loader> -->
          </span>
          <select-record-type
            v-else
            align="center"
            :isShowFollowUp="false"
            grid="20%"
            width="800px"
            @refreshData="$emit('refreshData')"
          ></select-record-type>
        </v-row>
      </v-col>
    </v-row>
    <due-date-dialog
      v-if="datePickVisible"
      :dateVisible.sync="datePickVisible"
      @close="closeDate"
      @setSelectDate="setSelectDate($event)"
    ></due-date-dialog>
  </v-container>
</template>

<script>
import SelectRecordType from '@/views/meeting/component/SelectRecordType'
// import Attendee from '@/views/meeting/component/card/Attendee'
// import { getWsMember } from '@/services/api'
import { setClipUpdate } from '@/services/clipApi'
import Toast from '@/views/meeting/component/Toast'
import { mapGetters } from 'vuex'
import { getTargetList } from '@/services/meetingApi'
// import { mapGetters, mapState } from 'vuex'
import DueDateDialog from '@/views/modal/DueDateDialog'

export default {
  components: { SelectRecordType, DueDateDialog },
  data() {
    return {
      memberList: [],
      wsInfo: this.$store.getters.selectedWsInfo,
      isMemberLoading: false,
      isClipUpdateLoading: false,
      selectedMember: null,
      datePickVisible: false,
      selectDate: null,
      displayDate: null,
      titleTooltip: true,
    }
  },
  created() {
    this.memberList = []
    if (this.userInfo) this.getMember()
    else this.selectedMember = this.currentClip.followUpInfo
  },
  methods: {
    async getMember() {
      try {
        this.isMemberLoading = true
        // this.memberList = await getWsMember(this, this.currentMt['wsId'])
        let result = await getTargetList(this, this.currentMt['mtId'], this.userInfo.userId, false)
        this.memberList = result.mtTargetList
      } catch (err) {
        // notify(this, 'Error', this.$t('general.error'), 'error')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('general.error'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
        this.isMemberLoading = false
      } finally {
        this.memberList.unshift({
          userDisplayName: 'Anyone',
          userPicture: 'Anyone',
          userId: '*',
        })
        this.memberList = JSON.parse(JSON.stringify(this.memberList))
        this.updateSelectedInfo()
        this.isMemberLoading = false
      }
    },
    updateSelectedInfo() {
      if (this.followUpInfoId && this.memberList && this.memberList.length > 0) {
        for (let i = 0; i < this.memberList.length; i++) {
          if (this.memberList[i].userId == this.followUpInfoId) {
            this.selectedMember = this.memberList[i]
          }
        }
      } else if (this.currentClip && this.currentClip['followUpInfo']) {
        this.selectedMember = this.currentClip['followUpInfo']
      } else {
        this.selectedMember = null
      }
      this.currentClip.expirationDate ? (this.selectDate = this.currentClip.expirationDate) : (this.selectDate = null)
    },
    selectMember(member) {
      this.selectedMember = member
      this.saveClip('member')
    },
    setSelectDate(value) {
      if (value) {
        this.selectDate = value.selectedDate
        this.displayDate = value.displayDate
        this.closeDate(value)
      }
    },
    openDialog() {
      this.datePickVisible = true
    },
    closeDate(value) {
      this.datePickVisible = false
      if (value) this.saveClip('date')
    },
    finish() {
      this.closeDate()
      this.$emit('finish')
    },
    async saveClip(val) {
      this.titleTooltip = true
      if (val) {
        this.isClipUpdateLoading = true
      } else {
        return
      }
      await this.$store.dispatch('setEditingClip', this.currentClip)
      this.setClipUpdate()
    },
    autoUpdate() {
      if (this.$refs.titleTxtF !== undefined) this.$refs.titleTxtF.blur()
      if (this.$refs.noteTxtF !== undefined) this.$refs.noteTxtF.blur()
      this.updateSelectedInfo()
    },
    async setClipUpdate() {
      if (this.editingClip && this.isClipOrganizer) {
        let clipIndex = this.totalSectionList[this.sectionIndex].clipList.findIndex(
          (clip) => clip.clipId === this.editingClip.clipId
        )
        if (clipIndex >= 0) {
          let followUpUid = this.selectedMember && this.selectedMember['userId'] ? this.selectedMember['userId'] : '*'
          this.totalSectionList[this.sectionIndex].clipList[clipIndex].clipNote = this.editingClip['clipNote']
          this.totalSectionList[this.sectionIndex].clipList[clipIndex].clipTitle = this.editingClip['clipTitle']
          this.totalSectionList[this.sectionIndex].clipList[clipIndex].expirationDate = this.selectDate
          this.totalSectionList[this.sectionIndex].clipList[clipIndex].followUpUid = followUpUid

          try {
            let updateClipResult = await setClipUpdate(
              this,
              this.currentMt['wsId'],
              this.currentMt['mtId'],
              this.editingClip['clipId'],
              this.editingClip['clipNote'],
              this.editingClip['clipTitle'],
              this.selectDate,
              this.displayDate,
              followUpUid
            )
            this.$store.dispatch('setCurrentClip', updateClipResult)
            // Request 요청 시 변동값 확인을 위해 추가
            await this.$store.dispatch('getAssignedCnt', this.currentMt['wsId'])
          } catch (error) {
            console.log(error)
          } finally {
            // await this.$store.dispatch('setIsLoading', false)
            this.isClipUpdateLoading = false
          }
        }
        // }
      }
    },
  },
  computed: {
    ...mapGetters(['currentClip', 'currentMt', 'userInfo', 'editingClip', 'sectionIndex', 'totalSectionList']),
    isClipOrganizer() {
      let clipUploader = this.currentClip ? this.currentClip.clipUploader : null
      if (clipUploader && this.userInfo) return clipUploader.userId === this.userInfo.userId
      else return false
    },
    dueDate() {
      let due = ''
      let expirationDate = ''
      if (
        this.currentClip &&
        this.currentClip !== null &&
        this.currentClip.expirationDate &&
        this.currentClip.expirationDate !== null
      ) {
        due = Date.now() >= this.currentClip.expirationDate ? 'Overdue' : 'Due - '
        expirationDate =
          due === 'Overdue'
            ? ''
            : this.$day
                .duration(this.$day().diff(this.currentClip.expirationDate))
                .humanize()
                .replace('a day', 'Tomorrow')
      }
      return due + expirationDate
    },
    isShowRequestedBy() {
      return this.currentClip.followUpInfo && this.currentClip.followUpInfo !== null
    },
    isShowClipTitle() {
      return this.currentClip.clipTitle && this.currentClip.clipTitle !== null
    },
    isShowDueDate() {
      return this.currentClip.expirationDate && this.currentClip.expirationDate !== null
    },
    isShowSelectRecordType() {
      let value = false
      if (this.currentClip && this.followUpInfoId && this.userInfo) value = this.followUpInfoId === this.userInfo.userId
      if (!this.followUpInfoId || this.followUpInfoId === '*') value = true
      return value
    },
    txtDate() {
      return this.displayDate && this.displayDate !== null ? this.displayDate : this.$t('selectDateHint')
    },
    clipTitle() {
      return this.currentClip.clipTitle
    },
    clipNote() {
      return this.currentClip.clipNote
    },
    followUpInfoId() {
      let id
      id = this.currentClip.followUpUid
        ? this.currentClip.followUpUid
        : this.currentClip.followUpInfo
        ? this.currentClip.followUpInfo.userId
        : null
      return id
    },
    gridStyle() {
      return {
        'grid-template-columns': 'repeat(auto-fit, 20%)',
        width: '800px',
      }
    },
  },
  watch: {
    currentClip() {
      this.autoUpdate()
    },
    sectionIndex() {
      this.autoUpdate()
    },
    isClipUpdateLoading(val) {
      // 클립 업데이트 중에는 하단 버튼들과 클립 이동 제한
      let listandbutton = document.querySelector('.container-list-and-button')
      if (listandbutton) {
        if (val) {
          listandbutton.style.pointerEvents = 'none'
        } else {
          listandbutton.style.pointerEvents = ''
        }
      }
    },
  },
}
</script>

<style>
.container-follow-up {
  height: calc(100vh - 140px);
}
@media (max-width: 959px) {
  .container-follow-up {
    height: calc(50vh);
  }
}
.container-follow-up-avatar {
  background: #43535e;
  border-radius: 15px;
}
.container-follow-up-title span {
  font-size: 18px;
  color: #eee;
  font-weight: 700;
}
.titleTxtF input::placeholder {
  color: #eee !important;
}
.container-requested-by-info {
  border-radius: 15px !important;
  min-width: 350px;
  max-width: 90%;
}
@media (max-width: 500px) {
  .container-follow-up-title span {
    font-size: 15px;
  }
  .container-requested-by-info {
    min-width: 300px;
  }
}
.container-requested-by-info-title {
  color: #96a7af;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  border-right: 1px solid #455764;
}
.container-requested-by-info-content {
  color: #96a7af;
  font-size: 14px;
  font-weight: 500;
}
.dialog-user-name {
  font-weight: 500 !important;
  font-size: 14px !important;
  color: white;
}
.textarea-title .v-text-field__slot input {
  color: #ffffff !important;
  /* overflow: hidden; */
  text-align: center;
  cursor: text;
}
.textarea-desc .v-text-field__slot textarea {
  color: #96a7af !important;
  line-height: 24px !important;
  text-align: center;
}
@media (max-width: 500px) {
  .textarea-title .v-text-field__slot input {
    padding-top: 3px;
  }
  .textarea-desc .v-text-field__slot textarea {
    line-height: 18px !important;
  }
}
.container-skeleton-btns {
  display: flex;
  justify-content: center !important;
  justify-items: center;
  align-content: center !important;
}
@media (max-width: 850px) {
  .container-skeleton-btns {
    width: 95% !important;
    justify-content: space-evenly !important;
  }
}
.container-skeleton-btn {
  border-radius: 15px !important;
  width: 340px;
  height: 87px;
  display: inline-flex;
  margin: 3px;
}
@media (max-width: 1263px) {
  .container-skeleton-btn {
    max-height: 80px;
    margin: 3px;
  }
}
@media (max-width: 959px) {
  .container-skeleton-btn {
    width: 90%;
    margin: 3px;
  }
}
</style>
